module.exports = __webpack_public_path__ + "img/b1-4.a8030d6.png";